/**
 * @description ISO 3166-1 alpha-2 codes for EU member states, used to route CloudFront-Viewer-Country
 * values to GDPRConsentPolicy. CloudFront sends these codes directly (e.g. "DE", "FR"), never "EU".
 * @filename eu-country-codes.ts
 */
export const EU_COUNTRY_CODES: string[] = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
];
